import { FC } from 'react';
import { Typography } from '@mui/material';

interface IFormTitle {
  title: string | boolean;
}

export const FormTitle: FC<IFormTitle> = ({ title }) => {
  return (
    <Typography
      variant="button"
      color="inherit"
      noWrap
      sx={{ fontSize: 20, fontWeight: 500 }}
    >
      {title}
    </Typography>
  );
};
